"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.PayInfo = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        position: 'fixed',
        zIndex: theme.zIndex.appBar,
        left: 0,
        right: 0,
        bottom: 0,
        padding: theme.spacing(3),
        background: theme.palette.background.paper,
        boxShadow: '0px 5px 30px 0px rgba(0, 0, 21, 0.20)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(3, 6)
        },
        [theme.breakpoints.up('lg')]: {
            display: 'none'
        }
    };
});
const PayInfo = exports.PayInfo = (0, _mui.styled)(_mui.Typography)({
    textAlign: 'center'
});
